/**
 * The GST "Time Period" range tokens. CUSTOM is FE-only — it means "use the explicit dates" and is
 * never sent as a rangeKey; the other three are resolved server-side.
 */
export const GST_RANGE_KEYS = {
    ALL: 'ALL',
    LAST_FY: 'LAST_FY',
    LAST_12M: 'LAST_12M',
    CUSTOM: 'CUSTOM',
} as const;

export type GstRangeKey = (typeof GST_RANGE_KEYS)[keyof typeof GST_RANGE_KEYS];

/**
 * Applied GST "Time Period" range, in the shape every range-aware GST backend call takes:
 * either a server-resolved `rangeKey` or an explicit month-snapped date pair.
 * Built by `buildGstRangeParams` in revenueVendorExpensesApiHelpers.
 */
export interface GstRangeParams {
    rangeKey?: GstRangeKey;
    startDate?: string;
    endDate?: string;
}

/** Metadata returned by the GST analysis report generate API. */
export interface GstAnalysisReportMeta {
    mnemosyneDocId?: number | string;
    fileName?: string;
}

/** A generated report resolved to a viewable doc (id + display name). */
export interface GstAnalysisReportDoc {
    docId: number | string;
    name: string;
}
